import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ReportGeneratorService} from '../../../services/report-generator.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'report-name-modal',
    templateUrl: './report-name-modal.component.html',
    styleUrls: ['./report-name-modal.component.scss']
})
export class ReportNameModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    name = '';
    disabledSubmit = false;

    constructor(
        public api: ApiClientService,
        public reportGeneratorService: ReportGeneratorService,
        public urlService: UrlService
    ) {}

    ngOnInit() {
        setTimeout( () => this.showModal = true, 300);
        this.initData();
        this.urlService.modalOpened.emit();
    }

    initData() {
        if(this.reportGeneratorService.reportInReportModal) {
            this.name = this.reportGeneratorService.reportInReportModal.name || this.reportGeneratorService.reportInReportModal.template.name;
        } else if(this.reportGeneratorService.templateInTemplateModal) {
            this.name = this.reportGeneratorService.templateInTemplateModal.name;
        }
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.reportGeneratorService.showReportNameModal = false;
                    this.reportGeneratorService.templateInTemplateModal = null;
                    this.reportGeneratorService.reportInReportModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.reportGeneratorService.showReportNameModal = false;
            this.reportGeneratorService.templateInTemplateModal = null;
            this.reportGeneratorService.reportInReportModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    onSubmit(form: NgForm) {
        if (!form.valid) {
            if (!form.value.name) toastr.warning('Name should not be blank.');
            return;
        }

        if(!this.name.trim()) {
            toastr.warning('Name should not be blank.');
            return;
        }

        const data: any = {
            name: this.name
        };

        this.disabledSubmit = true;
        if(this.reportGeneratorService.reportInReportModal) {
            const url = `/v1/reports/${this.reportGeneratorService.reportInReportModal.id}.json`;
            this.api.patch('domainReportGenerator', url, data).subscribe(
                () => this.updateView('Report name updated successfully'),
                error => {
                    this.disabledSubmit = false;
                    this.api.errorHandler(error, 'Failed to change report name');
                }
            );
        } else {
            this.reportGeneratorService.runReport(this.reportGeneratorService.templateInTemplateModal.id, this.name);
            this.form.reset();
            this.hideModal();
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        if(this.reportGeneratorService.reportInReportModal)
            this.reportGeneratorService.getData();
        this.form.reset();
        this.hideModal();
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/report-generator/report-name-modal/report-name-modal.component.ts